// image-grid.constants.ts
export const IMAGE_GRID = [
    {
        src: 'assets/logistics/warehouse_one.jpg',
        alt: 'SR Logistics India Private Limited'
    },
    {
        src: 'assets/logistics/warehouse_two.jpg',
        alt: 'SR Logistics India Private Limited'
    },
    {
        src: 'assets/logistics/warehouse_three.jpg',
        alt: 'SR Logistics India Private Limited'
    },
    {
        src: 'assets/logistics/warehouse_four.jpg',
        alt: 'SR Logistics India Private Limited'
    },
    {
        src: 'assets/logistics/warehouse_five.jpg',
        alt: 'SR Logistics India Private Limited'
    },
    // Add more images here
];
